import { AxiosRequestConfig } from 'axios'
import axiosInstance from '.'

interface Response {
  tenants: Tenant[]
  emailOwnershipVerificationRequired: boolean
}

export interface Tenant {
  id: string
  displayName: string
  userType: UserType
}

export enum UserType {
  UndefinedUser = 0,
  PreSignInUser = 1,
}

export async function getTenantsByEmailAddress(email: string, product?: string): Promise<Response | undefined> {
  const options: AxiosRequestConfig = {
    params: { email, product },
  }
  const { data } = await axiosInstance.get('/tenants', options)

  return data as Response
}

export async function getTenantsByExternalEntity(
  externalEntityId: string,
  dataCenter?: string,
  product?: string,
): Promise<Response | undefined> {
  const options: AxiosRequestConfig = {
    params: { externalEntityId, dataCenter, product },
  }
  const { data } = await axiosInstance.get('/tenants', options)

  return data as Response
}

export async function getTenant(tenantID: string, product: string): Promise<Tenant | undefined> {
  const options: AxiosRequestConfig = {
    params: { product },
  }
  const { data } = await axiosInstance.get(`/tenants/${tenantID}`, options)

  return data as Tenant
}
